module.exports = __webpack_public_path__ + "static/img/4.7f2089a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/4.png
// module id = dNB7
// module chunks = 0